import type { Book } from "./book";

import rawData from "./data.json";

export const data = (rawData as Book[])
  .map((book, index) => ({ book, index })) // preserve original index
  .sort((a, b) => {
    const titleCompare = a.book.title.localeCompare(b.book.title);
    if (titleCompare !== 0) return titleCompare;

    const aAuthor = a.book.author[0]?.name ?? "";
    const bAuthor = b.book.author[0]?.name ?? "";
    const authorCompare = aAuthor.localeCompare(bAuthor);
    if (authorCompare !== 0) return authorCompare;

    return a.book.id.localeCompare(b.book.id);
  })
  .map((entry) => entry.book); // unwrap
